import { SVGProps } from "react";

interface BackProps extends SVGProps<SVGSVGElement> {}

export function Back(props: BackProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={8}
      height={12}
      fill="none"
      {...props}
    >
      <path
        fill="#000"
        fillOpacity={0.56}
        d="M7.41 1.41 6 0 0 6l6 6 1.41-1.41L2.83 6l4.58-4.59Z"
      />
    </svg>
  );
}
